<template>
  <BaseIcon v-bind="$attrs">
    <template #svg>
      <SvgIcon
        class="arrow"
        :class="`arrow--${direction}`"
      />
    </template>
  </BaseIcon>
</template>

<script>
import SvgIcon from '@material-design-icons/svg/outlined/expand_more.svg';
import BaseIcon from './BaseIcon.vue';

export default {
  name: 'IconArrow',
  components: {
    BaseIcon,
    SvgIcon,
  },
  props: {
    direction: {
      type: String,
      default: 'down',
    },
  },
};
</script>

<style lang="scss" scoped>
.arrow {
  transition: 0.15s transform ease-in;

  &--right {
    transform: rotate(-90deg);
  }

  &--down {
    transform: rotate(0deg);
  }

  &--left {
    transform: rotate(90deg);
  }

  &--up {
    transform: rotate(180deg);
  }
}
</style>
